{
    "rapormusterigecici": {
        "Baslik": "Tijdelijke Machtigingsrapportage Klant",
        "Kullanici": "Gebruiker",
        "KullaniciGecici": "Tijdelijke Gebruiker",
        "AdSoyad": "Naam ve Achternaam",
        "Cep": "Mobiel",
        "Referans": "Referentie",
        "ID": "ID",
        "Takim": "Team",
        "Sube": "Filiaal",
        "Ara": "Zoeken",
        "Temizle": "Wissen",
        "Filtrele": "Filteren",
        "Sil": "Verwijderen",
        "Sayfada": "Op Pagina",
        "Olusturma": "Creatie",
        "Islem": "Actie",
        "R": "A",
        "S": "V",
        "O": "W",
        "I": "A",
        "C": "H",
        "R_Tooltip": "Aantal Afspraken",
        "S_Tooltip": "Goedgekeurde Verkoop",
        "O_Tooltip": "Wachtende Verkoop",
        "I_Tooltip": "Geannuleerde Verkoop",
        "C_Tooltip": "Ingetrokken Verkoop",
        "SilmeOnayMesaj": "Weet u zeker dat u deze tijdelijke machtiging wilt verwijderen?",
        "SilmeBasarisiz": "Verwijderen mislukt",
        "YetkinizYok": "U heeft geen toestemming.",
        "YetkiKaldirildi": "Tijdelijke machtiging verwijderd.",
        "Kapat": "Sluiten"
    }
}
